export interface KpiItem {
  icon: string;
  label: string;
  value: string;
  note?: string;
  noteTone?: "green" | "red" | "gray" | "teal";
  valueTone?: "default" | "teal" | "green";
}

export interface SliceDatum {
  name: string;
  value: number;
  color: string;
}

/* ===== TAB 1 — نظرة عامة ===== */
export const overviewKpis: KpiItem[] = [
  { icon: "ri-file-list-3-line", label: "إجمالي الطلبات", value: "247", note: "↑ 12% عن الشهر الماضي", noteTone: "green" },
  { icon: "ri-money-dollar-circle-line", label: "إجمالي المبيعات", value: "18,420 ر.س", note: "↑ 8%", noteTone: "green" },
  { icon: "ri-percent-line", label: "متوسط قيمة الطلب", value: "75 ر.س", note: "ثابت", noteTone: "gray", valueTone: "teal" },
  { icon: "ri-checkbox-circle-line", label: "نسبة الإكمال", value: "92%", note: "228 من 247", noteTone: "gray", valueTone: "green" },
];

export const dailySalesOrders: { day: string; sales: number; orders: number }[] = [
  { day: "1", sales: 520, orders: 7 },
  { day: "2", sales: 610, orders: 8 },
  { day: "3", sales: 480, orders: 6 },
  { day: "4", sales: 720, orders: 10 },
  { day: "5", sales: 890, orders: 12 },
  { day: "6", sales: 760, orders: 10 },
  { day: "7", sales: 540, orders: 7 },
  { day: "8", sales: 620, orders: 9 },
  { day: "9", sales: 580, orders: 8 },
  { day: "10", sales: 810, orders: 11 },
  { day: "11", sales: 940, orders: 13 },
  { day: "12", sales: 700, orders: 9 },
  { day: "13", sales: 560, orders: 8 },
  { day: "14", sales: 650, orders: 9 },
  { day: "15", sales: 730, orders: 10 },
  { day: "16", sales: 880, orders: 12 },
  { day: "17", sales: 990, orders: 13 },
  { day: "18", sales: 760, orders: 10 },
  { day: "19", sales: 610, orders: 8 },
  { day: "20", sales: 690, orders: 9 },
  { day: "21", sales: 770, orders: 11 },
  { day: "22", sales: 920, orders: 12 },
  { day: "23", sales: 1040, orders: 14 },
  { day: "24", sales: 800, orders: 11 },
  { day: "25", sales: 640, orders: 9 },
  { day: "26", sales: 720, orders: 10 },
  { day: "27", sales: 810, orders: 11 },
  { day: "28", sales: 950, orders: 13 },
  { day: "29", sales: 1080, orders: 14 },
  { day: "30", sales: 860, orders: 12 },
];

export const serviceDistribution: SliceDatum[] = [
  { name: "غسيل سيارات", value: 111, color: "#00AAB7" },
  { name: "تنظيف منازل", value: 74, color: "#27AE60" },
  { name: "مغاسل ملابس", value: 62, color: "#4A90D9" },
];

export interface ServiceSummaryRow {
  service: string;
  orders: number;
  revenue: number;
  avg: number;
  cancel: string;
  total?: boolean;
}

export const serviceSummary: ServiceSummaryRow[] = [
  { service: "غسيل سيارات", orders: 112, revenue: 8400, avg: 75, cancel: "3%" },
  { service: "تنظيف منازل", orders: 74, revenue: 6200, avg: 84, cancel: "5%" },
  { service: "مغاسل ملابس", orders: 61, revenue: 3820, avg: 63, cancel: "2%" },
  { service: "الإجمالي", orders: 247, revenue: 18420, avg: 75, cancel: "3%", total: true },
];

/* ===== TAB 2 — الطلبات ===== */
export const ordersKpis: KpiItem[] = [
  { icon: "ri-file-list-3-line", label: "إجمالي الطلبات", value: "247" },
  { icon: "ri-checkbox-circle-line", label: "مكتملة", value: "228", note: "92%", noteTone: "green", valueTone: "green" },
  { icon: "ri-close-circle-line", label: "ملغاة", value: "12", note: "5%", noteTone: "red", valueTone: "default" },
  { icon: "ri-timer-line", label: "متوسط وقت التنفيذ", value: "38 دقيقة", valueTone: "teal" },
];

export const dailyServiceOrders: { day: string; carWash: number; cleaning: number; laundry: number }[] = [
  { day: "السبت", carWash: 14, cleaning: 9, laundry: 7 },
  { day: "الأحد", carWash: 18, cleaning: 11, laundry: 8 },
  { day: "الاثنين", carWash: 12, cleaning: 8, laundry: 6 },
  { day: "الثلاثاء", carWash: 16, cleaning: 10, laundry: 9 },
  { day: "الأربعاء", carWash: 20, cleaning: 12, laundry: 10 },
  { day: "الخميس", carWash: 15, cleaning: 9, laundry: 8 },
  { day: "الجمعة", carWash: 17, cleaning: 11, laundry: 9 },
];

export const topServices: { label: string; value: number }[] = [
  { label: "غسل خارجي وداخلي", value: 67 },
  { label: "تنظيف شامل", value: 45 },
  { label: "غسيل وكوي", value: 38 },
  { label: "عاملة بالساعة", value: 29 },
  { label: "تلميع كامل", value: 23 },
];

export const orderStatus: SliceDatum[] = [
  { name: "مكتمل", value: 92, color: "#27AE60" },
  { name: "ملغي من العميل", value: 5, color: "#F59E0B" },
  { name: "مرفوض", value: 3, color: "#E74C3C" },
];

/* ===== TAB 3 — المبيعات ===== */
export const salesKpis: KpiItem[] = [
  { icon: "ri-money-dollar-circle-line", label: "إجمالي المبيعات", value: "18,420 ر.س", valueTone: "teal" },
  { icon: "ri-arrow-up-line", label: "أعلى يوم", value: "1,890 ر.س", valueTone: "green" },
  { icon: "ri-arrow-down-line", label: "أقل يوم", value: "320 ر.س" },
  { icon: "ri-bar-chart-line", label: "متوسط يومي", value: "614 ر.س" },
];

export interface ComparisonRow {
  label: string;
  current: string;
  previous: string;
  change: string;
  tone: "green" | "red";
}

export const comparisonRows: ComparisonRow[] = [
  { label: "المبيعات", current: "18,420", previous: "16,900", change: "↑ 9%", tone: "green" },
  { label: "الطلبات", current: "247", previous: "219", change: "↑ 13%", tone: "green" },
  { label: "متوسط الطلب", current: "75", previous: "77", change: "↓ 3%", tone: "red" },
  { label: "الإلغاءات", current: "12", previous: "18", change: "↓ 33%", tone: "green" },
];

export const topRevenueServices: { label: string; value: number }[] = [
  { label: "غسل خارجي وداخلي", value: 5200 },
  { label: "تنظيف شامل", value: 4100 },
  { label: "تلميع كامل", value: 2760 },
];

/* ===== TAB 4 — العملاء ===== */
export const customersKpis: KpiItem[] = [
  { icon: "ri-user-3-line", label: "إجمالي العملاء", value: "186" },
  { icon: "ri-user-add-line", label: "جدد هذا الشهر", value: "34", valueTone: "teal" },
  { icon: "ri-repeat-line", label: "متكررين", value: "72", note: "39%", noteTone: "green" },
  { icon: "ri-wallet-3-line", label: "متوسط إنفاق", value: "99 ر.س" },
];

export const newCustomers: { month: string; value: number }[] = [
  { month: "مارس", value: 18 },
  { month: "أبريل", value: 22 },
  { month: "مايو", value: 27 },
  { month: "يونيو", value: 25 },
  { month: "يوليو", value: 30 },
  { month: "أغسطس", value: 34 },
];

export const customerFrequency: SliceDatum[] = [
  { name: "طلب واحد", value: 61, color: "#8AAFAF" },
  { name: "2-5 طلبات", value: 28, color: "#00AAB7" },
  { name: "أكثر من 5", value: 11, color: "#27AE60" },
];

export const topCustomers: { label: string; value: number }[] = [
  { label: "أحمد محمد", value: 12 },
  { label: "فاطمة المالكي", value: 9 },
  { label: "سارة العتيبي", value: 8 },
  { label: "خالد الحربي", value: 7 },
  { label: "نورة القحطاني", value: 6 },
];

export interface CustomerRow {
  name: string;
  orders: number;
  spend: string;
  favorite: string;
  last: string;
}

export const customersTable: CustomerRow[] = [
  { name: "أحمد محمد", orders: 12, spend: "940 ر.س", favorite: "غسيل سيارات", last: "16 أغسطس" },
  { name: "فاطمة المالكي", orders: 9, spend: "810 ر.س", favorite: "تنظيف منازل", last: "15 أغسطس" },
  { name: "سارة العتيبي", orders: 8, spend: "690 ر.س", favorite: "مغاسل ملابس", last: "14 أغسطس" },
  { name: "خالد الحربي", orders: 7, spend: "560 ر.س", favorite: "غسيل سيارات", last: "13 أغسطس" },
  { name: "نورة القحطاني", orders: 6, spend: "480 ر.س", favorite: "تنظيف منازل", last: "12 أغسطس" },
];

/* ===== TAB 5 — الفريق ===== */
export const teamKpis: KpiItem[] = [
  { icon: "ri-team-line", label: "عدد الفنيين", value: "8" },
  { icon: "ri-task-line", label: "المهام المكتملة", value: "228", valueTone: "green" },
  { icon: "ri-star-line", label: "متوسط التقييم", value: "4.7 ★", valueTone: "teal" },
  { icon: "ri-thumb-up-line", label: "نسبة القبول", value: "94%", valueTone: "green" },
];

export interface TeamRow {
  name: string;
  tasks: number;
  rating: string;
  avgTime: string;
  accept: string;
  status: string;
  statusTone: "green" | "amber";
}

export const teamPerformance: TeamRow[] = [
  { name: "فريق أ (3)", tasks: 45, rating: "4.8 ★", avgTime: "35 د", accept: "96%", status: "متاح ✓", statusTone: "green" },
  { name: "فريق ب (2)", tasks: 38, rating: "4.6 ★", avgTime: "42 د", accept: "91%", status: "مشغول", statusTone: "amber" },
  { name: "أحمد", tasks: 22, rating: "4.9 ★", avgTime: "30 د", accept: "98%", status: "متاح ✓", statusTone: "green" },
];

export const teamTasksChart: { label: string; value: number }[] = [
  { label: "فريق أ", value: 45 },
  { label: "فريق ب", value: 38 },
  { label: "أحمد", value: 22 },
  { label: "فاطمة", value: 19 },
  { label: "خالد", value: 17 },
  { label: "نورة", value: 15 },
  { label: "سعد", value: 12 },
  { label: "ريم", value: 10 },
];